import type { TranslationConfig } from '@bcf-v2/routes-statics/common/app/i18n-cache';
import { langRoutePath } from '@bcf-v2/routes/common/app/paths/lang-route-path';
import { slotsRouteI18n } from '../i18n/slots-route-i18n';

export function slotsRoutePath(config?: TranslationConfig): string {
  return `${langRoutePath(config)}/${slotsRouteI18n(config)}`;
}
